/** Neutral “no photo”; canlıda tam URL (`https://demaxtore.com/...`) — kart/detay/yedek src tutarlı olsun. */
function buildProductPlaceholderSrc() {
  const explicit = String(process.env.REACT_APP_PRODUCT_PLACEHOLDER_URL || '').trim().replace(/\/+$/, '');
  if (explicit) return explicit;
  if (process.env.NODE_ENV === 'production') {
    return 'https://demaxtore.com/product-placeholder.png';
  }
  return `${process.env.PUBLIC_URL || ''}/product-placeholder.png`.replace(/([^:]\/)\/+/g, '$1');
}

export const PRODUCT_PLACEHOLDER_SRC = buildProductPlaceholderSrc();

function isProductPlaceholderPath(s) {
  const raw = String(s || '').trim();
  if (!raw) return false;
  const noQuery = raw.split(/[?#]/)[0];
  try {
    if (/^https?:\/\//i.test(noQuery)) {
      const u = new URL(noQuery);
      return u.pathname.toLowerCase().endsWith('/product-placeholder.png');
    }
  } catch {
    /* ignore */
  }
  const t = noQuery.toLowerCase();
  return t === '/product-placeholder.png' || /\/product-placeholder\.png$/i.test(t);
}

/** Hotlink / anti-leech: many Woo hosts reject foreign Referer — empty referrer often fixes 403. */
export const PRODUCT_IMG_REFERRER_POLICY = 'no-referrer';

function envBlocksDemaxtoreWpImages() {
  const v = String(process.env.REACT_APP_BLOCK_DEMAXTORE_WP_IMAGES || '')
    .trim()
    .toLowerCase();
  return v === 'true' || v === '1' || v === 'yes';
}

/**
 * true → Uzak Woo `…/wp-content/uploads/…` ve `/wp-content/uploads/…` yolları `public/uploads` ile
 * servis edilen `/uploads/…` adresine çevrilir. `/catalog-images/…` yerel statik katalogdur; aynı
 * kalır (dosyalar `public/catalog-images/` altında). Diğer dış URL’ler placeholder’a düşer.
 */
function publicUploadsImagesEnabled() {
  const v = String(process.env.REACT_APP_USE_PUBLIC_UPLOADS || '')
    .trim()
    .toLowerCase();
  return v === 'true' || v === '1' || v === 'yes';
}

/**
 * `USE_PUBLIC_UPLOADS` açıkken bile tam `https://…/wp-content/uploads/…` adreslerini yerelde
 * `/uploads/…`e çevirmeden bırakır (Plesk / Woo üzerinden yüklenir). Katalog JSON’da
 * `/catalog-images/…` varken dosyalar repoda yoksa kart `onError` ile yedeklenebilir.
 * - Açık: `REACT_APP_WOO_IMAGES_REMOTE_WITH_PUBLIC_UPLOADS=true`
 * - Kapalı: `…=false`
 * - Boş: yalnızca geliştirmede açık
 */
function wooImagesRemoteWithPublicUploads() {
  const v = String(process.env.REACT_APP_WOO_IMAGES_REMOTE_WITH_PUBLIC_UPLOADS || '')
    .trim()
    .toLowerCase();
  if (v === 'true' || v === '1' || v === 'yes') return true;
  if (v === 'false' || v === '0' || v === 'no') return false;
  return process.env.NODE_ENV === 'development';
}

const WP_CONTENT_UPLOADS = '/wp-content/uploads';

/**
 * CSV / Mongo’da sık görülen `uploads/...` ve `catalog-images/...` (başında `/` yok) yollarını
 * kök-relative yapar; aksi halde hem `isDiscardedExternalProductImage` hem `resolveProductImageUrlInner`
 * yanlışlıkla placeholder’a düşer.
 */
function normalizeProductImagePathOrUrl(url) {
  const s = String(url == null ? '' : url).trim();
  if (!s || s.startsWith('data:')) return s;
  if (s.startsWith('/') || /^https?:\/\//i.test(s) || s.startsWith('//')) return s;
  const low = s.toLowerCase();
  if (low.startsWith('uploads/') || low === 'uploads') return `/${s}`;
  if (low.startsWith('catalog-images/')) return `/${s}`;
  if (low.startsWith('wp-content/uploads/') || low === 'wp-content/uploads') return `/${s}`;
  return s;
}

/**
 * Uzak veya same-origin Woo upload URL’sini `frontend/public/uploads` ile servis edilen köke çevirir.
 * Eşleşme yoksa boş string döner (çağıran aynı URL ile devam eder).
 */
export function wooUploadsUrlToPublicUploadsPath(urlOrPath) {
  if (!publicUploadsImagesEnabled()) return '';
  const raw = normalizeProductImagePathOrUrl(urlOrPath);
  if (!raw) return '';
  const lower = raw.toLowerCase();
  const idx = lower.indexOf(WP_CONTENT_UPLOADS);
  if (idx === -1) return '';
  const after = raw.slice(idx + WP_CONTENT_UPLOADS.length);
  const suffix = after.startsWith('/') ? after : `/${after}`;
  const base = process.env.PUBLIC_URL || '';
  return `${base}/uploads${suffix}`.replace(/([^:]\/)\/+/g, '$1');
}

/**
 * URLs to skip when building the gallery list (optional Woo block only).
 */
export function isDiscardedExternalProductImage(url) {
  if (!url || !String(url).trim()) return true;
  const t = normalizeProductImagePathOrUrl(url);
  const s = t.toLowerCase();
  if (publicUploadsImagesEnabled()) {
    if (s.includes('/wp-content/uploads')) return false;
    if (s.startsWith('/uploads/') || s === '/uploads') return false;
    if (s.startsWith('/catalog-images/')) return false;
    // Tam URL (örn. CSV: https://demaxtore.com/catalog-images/… veya /uploads/…)
    if (s.includes('/uploads/')) return false;
    if (s.includes('/catalog-images/')) return false;
    return true;
  }
  if (s.includes('/wp-content/uploads')) return false;
  if (envBlocksDemaxtoreWpImages() && s.includes('demaxtore.com/wp-content')) return true;
  return false;
}

export function isPlaceholderImageSrc(src) {
  if (src == null || src === '') return true;
  const s = String(src);
  if (s.includes('product-placeholder.png')) return true;
  if (s.startsWith('data:image/svg+xml')) return true;
  if (s === 'about:blank') return true;
  return false;
}

/** Woo uploads: CSV’deki tam URL’ler + açıklamadaki `/wp-content/...` için kök (production: demaxtore.com). */
const WC_MEDIA_ORIGIN = (
  process.env.REACT_APP_WC_MEDIA_ORIGIN || 'https://demaxtore.com'
)
  .trim()
  .replace(/\/+$/, '');

/**
 * true → Katalogdaki `/uploads/…` / `/catalog-images/…` uzak Woo (`REACT_APP_WC_MEDIA_ORIGIN`) adresine çevrilir.
 * false → Aynı kökten servis: build çıktısındaki `public/uploads` = canlıda `backend/public/uploads` (nginx statik).
 * Varsayılan: false (VPS’teki upload kopyası kullanılır). Repoda/kopyada dosya yok, yalnız Woo’da varsa: `=true`.
 */
function productImagesPreferWooMediaOrigin() {
  const v = String(process.env.REACT_APP_PRODUCT_IMAGES_FROM_WC_MEDIA_ORIGIN ?? '')
    .trim()
    .toLowerCase();
  if (v === 'false' || v === '0' || v === 'no') return false;
  if (v === 'true' || v === '1' || v === 'yes') return true;
  return false;
}

/**
 * @param {string} s — normalize edilmiş path
 * @returns {string} Tam `https://…` veya boş
 */
function resolveRootRelativeProductPathViaWcMediaOrigin(s) {
  if (!productImagesPreferWooMediaOrigin()) return '';
  const raw = String(s || '').trim();
  if (!raw) return '';
  const low = raw.toLowerCase();
  const wc = WC_MEDIA_ORIGIN;
  if (low.startsWith('/uploads/') || low === '/uploads') {
    const path = low === '/uploads' ? '/uploads' : raw;
    return `${wc}/wp-content${path}`.replace(/([^:]\/)\/+/g, '$1');
  }
  if (low.startsWith('/catalog-images/')) {
    const rest = raw.slice('/catalog-images'.length);
    return `${wc}/wp-content/uploads${rest}`.replace(/([^:]\/)\/+/g, '$1');
  }
  return '';
}

/**
 * true: `<img src="/wp-content/...">` (localhost veya canlıda aynı domain + reverse proxy).
 * - Geliştirmede varsayılan açık (`npm start` + setupProxy.js).
 * - Production’da nginx vb. `/wp-content` → WordPress proxylüyorsa `REACT_APP_WOO_MEDIA_SAME_ORIGIN=true`.
 */
function wooMediaSameOrigin() {
  const v = String(process.env.REACT_APP_WOO_MEDIA_SAME_ORIGIN || '')
    .trim()
    .toLowerCase();
  if (v === 'true' || v === '1' || v === 'yes') return true;
  if (v === 'false' || v === '0' || v === 'no') return false;
  return process.env.NODE_ENV === 'development';
}

/** `https://host/wp-content/...` → dev’de `/wp-content/...` (proxy); production’da tam Woo kökü (kırık göreli yol yok). */
function toSameOriginWooMediaPath(absoluteUrl) {
  if (!wooMediaSameOrigin()) return absoluteUrl;
  try {
    const u = new URL(String(absoluteUrl));
    if (u.pathname.startsWith('/wp-content') || u.pathname.startsWith('/wp-includes')) {
      if (process.env.NODE_ENV === 'production') {
        return `${WC_MEDIA_ORIGIN}${u.pathname}${u.search || ''}`.replace(/([^:]\/)\/+/g, '$1');
      }
      return `${u.pathname}${u.search || ''}`;
    }
  } catch {
    /* ignore */
  }
  return absoluteUrl;
}

/**
 * Optional CDN: `REACT_APP_PRODUCT_IMAGE_BASE_ORIGIN` — demaxtore.com hostunu buna çevirir.
 * Aksi halde kalan eski `demaxtore.com/wp-content` adresleri `REACT_APP_WC_MEDIA_ORIGIN` (köke) yönlendirilir.
 */
function rewriteLegacyImageHosts(absoluteUrl) {
  let u = String(absoluteUrl);
  const alt = (process.env.REACT_APP_PRODUCT_IMAGE_BASE_ORIGIN || '').trim().replace(/\/+$/, '');
  if (alt) {
    return u.replace(/^https?:\/\/(www\.)?demaxtore\.com/i, alt);
  }
  if (/^https?:\/\/(www\.)?demaxtore\.com\/wp-content/i.test(u)) {
    return u.replace(/^https?:\/\/(www\.)?demaxtore\.com/i, WC_MEDIA_ORIGIN);
  }
  return u;
}

/**
 * Örn. `https://demaxtore.com` — ürün görselleri tam URL olsun (`https://demaxtore.com/uploads/...`).
 * Boş bırakılırsa göreli `/uploads/...` ve mevcut davranış korunur.
 */
function productImageAbsoluteOrigin() {
  return String(process.env.REACT_APP_PRODUCT_IMAGE_ABSOLUTE_ORIGIN || '').trim().replace(/\/+$/, '');
}

/**
 * `/uploads/…`, `/catalog-images/…` ve tam URL’lerde site kökü ile hizalama.
 * Uzak WordPress (`…/wp-content/uploads/…` başka hostta) asla `demaxtore.com/uploads/…` yapılmaz.
 */
function canonicalProductMediaUrl(resolved) {
  if (resolved == null) return resolved;
  const s = String(resolved).trim();
  if (!s || s.startsWith('data:')) return resolved;
  if (isProductPlaceholderPath(s)) return resolved;

  let siteOriginFromEnv = '';
  try {
    const abs = productImageAbsoluteOrigin();
    if (abs) siteOriginFromEnv = new URL(abs.match(/^https?:\/\//i) ? abs : `https://${abs}`).origin;
  } catch {
    siteOriginFromEnv = '';
  }

  try {
    if (/^https?:\/\//i.test(s)) {
      const u = new URL(s);
      const wcRoot = new URL(`${WC_MEDIA_ORIGIN.replace(/\/+$/, '')}/`);
      if (u.origin === wcRoot.origin) return resolved;

      const lowPath = u.pathname.toLowerCase();
      if (lowPath.includes('/wp-content/uploads')) {
        if (!siteOriginFromEnv || u.origin !== siteOriginFromEnv) {
          return resolved;
        }
      }
    }
  } catch {
    /* ignore */
  }

  /** Kök-relative `/wp-content/uploads/…` — site SEO kökü olmadan da Woo’da dosya vardır. */
  if (!/^https?:\/\//i.test(s)) {
    const low = s.toLowerCase();
    if (
      low.startsWith('/wp-content/uploads') ||
      low === '/wp-content/uploads' ||
      (low.startsWith('/wp-content/') && low.includes('/uploads'))
    ) {
      const path = s.startsWith('/') ? s : `/${s}`;
      return `${WC_MEDIA_ORIGIN}${path}`.replace(/([^:]\/)\/+/g, '$1');
    }
  }

  const origin = productImageAbsoluteOrigin();
  if (!origin) return resolved;

  const join = (pathname, search = '') => {
    const pathOnly = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return `${origin}${pathOnly}${search}`.replace(/([^:]\/)\/+/g, '$1');
  };

  if (!/^https?:\/\//i.test(s)) {
    const low = s.toLowerCase();
    if (low.startsWith('/uploads/') || low === '/uploads' || low.startsWith('/catalog-images/')) {
      return join(s);
    }
    return resolved;
  }

  try {
    const u = new URL(s);
    const p = u.pathname;
    const lowPath = p.toLowerCase();
    const q = u.search || '';
    if (lowPath.startsWith('/uploads/') || lowPath === '/uploads' || lowPath.startsWith('/catalog-images/')) {
      return join(p, q);
    }
    const wpi = lowPath.indexOf('/wp-content/uploads');
    if (wpi !== -1) {
      const after = p.slice(wpi + '/wp-content/uploads'.length);
      const suffix = after.startsWith('/') ? after : `/${after}`;
      return join(`/uploads${suffix}`, q);
    }
  } catch {
    return resolved;
  }
  return resolved;
}

/**
 * Normalize URLs for <img src>: protocol-relative, root-relative Woo paths, optional host rewrite.
 * Keeps same-origin placeholder paths on the app host (never prefixes demaxtore.com).
 */
function resolveProductImageUrlInner(url) {
  if (url == null) return '';
  let s = normalizeProductImagePathOrUrl(url);
  if (!s) return '';
  if (s.startsWith('data:')) return s;
  if (isProductPlaceholderPath(s)) {
    return buildProductPlaceholderSrc();
  }

  const viaWc = resolveRootRelativeProductPathViaWcMediaOrigin(s);
  if (viaWc) return viaWc;

  if (publicUploadsImagesEnabled()) {
    if (wooImagesRemoteWithPublicUploads()) {
      let abs = s;
      if (abs.startsWith('//')) abs = `https:${abs}`;
      if (/^https?:\/\//i.test(abs) && /\/wp-content\/uploads\//i.test(abs)) {
        return toSameOriginWooMediaPath(rewriteLegacyImageHosts(abs));
      }
    }
    const mapped = wooUploadsUrlToPublicUploadsPath(s);
    if (mapped) return mapped;
    const low = s.toLowerCase();
    if (low.startsWith('/uploads/') || low === '/uploads') {
      const base = process.env.PUBLIC_URL || '';
      return `${base}${s}`.replace(/([^:]\/)\/+/g, '$1');
    }
    if (low.startsWith('/catalog-images/')) {
      const base = process.env.PUBLIC_URL || '';
      return `${base}${s}`.replace(/([^:]\/)\/+/g, '$1');
    }
    // Tam URL ama kendi sitede servis edilen katalog / uploads (CSV / Mongo)
    if (/\/catalog-images\//i.test(low)) {
      try {
        const abs = s.startsWith('//') ? `https:${s}` : s;
        const u = new URL(abs);
        const pathname = u.pathname || '';
        if (pathname.toLowerCase().startsWith('/catalog-images/')) {
          const base = process.env.PUBLIC_URL || '';
          return `${base}${pathname}${u.search || ''}`.replace(/([^:]\/)\/+/g, '$1');
        }
      } catch {
        /* ignore */
      }
    }
    if (/\/uploads\//i.test(low) && !/\/wp-content\/uploads\//i.test(low)) {
      try {
        const abs = s.startsWith('//') ? `https:${s}` : s;
        const u = new URL(abs);
        const pathname = u.pathname || '';
        if (pathname.toLowerCase().startsWith('/uploads/')) {
          const base = process.env.PUBLIC_URL || '';
          return `${base}${pathname}${u.search || ''}`.replace(/([^:]\/)\/+/g, '$1');
        }
      } catch {
        /* ignore */
      }
    }
    if (/\/product-placeholder\.png$/i.test(s) || s.includes('/static/')) {
      const base = process.env.PUBLIC_URL || '';
      return `${base}${s}`.replace(/([^:]\/)\/+/g, '$1');
    }
    return PRODUCT_PLACEHOLDER_SRC;
  }

  const fromUploads = wooUploadsUrlToPublicUploadsPath(s);
  if (fromUploads) return fromUploads;

  if (s.startsWith('/')) {
    if (/\/product-placeholder\.png$/i.test(s) || s.includes('/static/')) {
      const base = process.env.PUBLIC_URL || '';
      return `${base}${s}`.replace(/([^:]\/)\/+/g, '$1');
    }
    if (s.startsWith('/wp-content') || s.startsWith('/wp-includes')) {
      if (wooMediaSameOrigin()) {
        const base = process.env.PUBLIC_URL || '';
        return `${base}${s}`.replace(/([^:]\/)\/+/g, '$1');
      }
      return toSameOriginWooMediaPath(rewriteLegacyImageHosts(`${WC_MEDIA_ORIGIN}${s}`));
    }
    const base = process.env.PUBLIC_URL || '';
    return `${base}${s}`.replace(/([^:]\/)\/+/g, '$1');
  }

  if (s.startsWith('//')) s = `https:${s}`;
  if (!/^https?:\/\//i.test(s)) return s;

  return toSameOriginWooMediaPath(rewriteLegacyImageHosts(s));
}

export function resolveProductImageUrl(url) {
  return canonicalProductMediaUrl(resolveProductImageUrlInner(url));
}

/**
 * Woo açıklama HTML’indeki tam URL’leri (geliştirmede) `/wp-content/...` yapar — setupProxy ile localhost’ta açılır.
 */
export function rewriteHtmlWooMediaSrcs(html) {
  if (html == null || html === '') return html;
  if (!wooMediaSameOrigin() && !publicUploadsImagesEnabled()) return html;
  let h = String(html);
  h = h.replace(/\bsrc=(["'])(https?:\/\/[^"']*?)\1/gi, (m, q, url) => {
    if (!/\/wp-content\/|\/wp-includes\//i.test(url)) return m;
    const out = resolveProductImageUrl(url.trim());
    return out && out !== url ? `src=${q}${out}${q}` : m;
  });
  h = h.replace(/\bsrcset=(["'])([^"']+)\1/gi, (m, q, val) => {
    const parts = val.split(',').map((p) => p.trim()).filter(Boolean);
    if (!parts.length) return m;
    const next = parts.map((part) => {
      const bits = part.split(/\s+/).filter(Boolean);
      const u = bits[0];
      if (!u || !/^https?:\/\//i.test(u) || !/\/wp-content\/|\/wp-includes\//i.test(u)) return part;
      const out = resolveProductImageUrl(u);
      const rest = bits.slice(1).join(' ');
      return rest ? `${out} ${rest}` : out;
    });
    return `srcset=${q}${next.join(', ')}${q}`;
  });
  return h;
}

function dedupeProductImageUrls(urls) {
  const seen = new Set();
  const out = [];
  for (const u of urls) {
    if (!u || seen.has(u)) continue;
    seen.add(u);
    out.push(u);
  }
  return out;
}

/** Pathname son segmenti (sorgu dizesi atılır). */
function lastPathSegmentFromUrl(url) {
  let pathname = String(url || '').trim().split('?')[0];
  if (!pathname) return '';
  try {
    if (/^https?:\/\//i.test(pathname) || pathname.startsWith('//')) {
      pathname = new URL(pathname.startsWith('//') ? `https:${pathname}` : pathname).pathname;
    }
  } catch {
    return '';
  }
  const parts = pathname.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
}

/** Woo ölçek eki: `dosya-400x267.webp` → `dosya.webp` (sona bitişik tekrarlar). `-scaled.webp` → `.webp` (Woo ara boy). */
function wpStripScaledSuffixes(filename) {
  let name = String(filename || '');
  for (let g = 0; g < 16; g++) {
    const next = name.replace(/-\d+x\d+(\.[^.]+)$/i, '$1');
    if (next === name) break;
    name = next;
  }
  name = name.replace(/-scaled(\.[^.]+)$/i, '$1');
  return name.toLowerCase();
}

/** Aynı “asıl” görsel (ölçek ekleri çıkarılınca) için tek anahtar. */
function canonicalGalleryKeyFromUrl(url) {
  const pathname = String(url || '')
    .trim()
    .split('?')[0];
  if (!pathname) return '';
  let path = pathname;
  try {
    if (/^https?:\/\//i.test(pathname) || pathname.startsWith('//')) {
      path = new URL(pathname.startsWith('//') ? `https:${pathname}` : pathname).pathname;
    }
  } catch {
    return '';
  }
  const i = path.lastIndexOf('/');
  const dir = i >= 0 ? path.slice(0, i).toLowerCase() : '';
  const file = i >= 0 ? path.slice(i + 1) : path;
  const stem = wpStripScaledSuffixes(file);
  return `${dir}/${stem}`;
}

/**
 * Yerel `/uploads/…` ile Woo `…/wp-content/uploads/…` aynı dosyayı mı gösteriyor diye karşılaştırma
 * (`canonicalGalleryKeyFromUrl` dizin önekleri farklı olduğu için burada kullanılmaz).
 */
function galleryAlignmentKeyFromUrl(url) {
  const pathname = String(url || '')
    .trim()
    .split('?')[0];
  if (!pathname) return '';
  let path = pathname.replace(/\\/g, '/');
  try {
    if (/^https?:\/\//i.test(pathname) || pathname.startsWith('//')) {
      path = new URL(pathname.startsWith('//') ? `https:${pathname}` : pathname).pathname.replace(/\\/g, '/');
    }
  } catch {
    return '';
  }
  const lower = path.toLowerCase();
  const wp = '/wp-content/uploads/';
  const up = '/uploads/';
  const cat = '/catalog-images/';
  let rel = '';
  const iWp = lower.indexOf(wp);
  if (iWp !== -1) {
    rel = path.slice(iWp + wp.length);
  } else {
    const iCat = lower.indexOf(cat);
    if (iCat !== -1) {
      rel = path.slice(iCat + cat.length);
    } else {
      const iUp = lower.indexOf(up);
      if (iUp !== -1) {
        rel = path.slice(iUp + up.length);
      } else {
        const file = path.split('/').filter(Boolean).pop() || '';
        return wpStripScaledSuffixes(file);
      }
    }
  }
  rel = rel.replace(/^\/+/, '');
  const slash = rel.lastIndexOf('/');
  const dir = slash >= 0 ? rel.slice(0, slash).toLowerCase() : '';
  const file = slash >= 0 ? rel.slice(slash + 1) : rel;
  const stem = wpStripScaledSuffixes(file);
  if (!stem) return '';
  return dir ? `${dir}/${stem}` : stem;
}

/** Kaç farklı “asıl” görsel var (aynı dosyanın WxH varyantları tek sayılır). */
function countDistinctCanonicalGallerySubjects(urls) {
  if (!Array.isArray(urls) || !urls.length) return 0;
  const keys = new Set();
  for (const u of urls) {
    const k = canonicalGalleryKeyFromUrl(u);
    if (k) keys.add(k);
  }
  return keys.size;
}

/** Ürün adı → `applyLocalCatalogImages` ile uyumlu slug (Türkçe aksan sadeleştirme). */
function slugKeyProductName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[()]/g, ' ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Ürün adından ayırt edici parçalar (çok genel kelimeler çıkarılır). */
const GENERIC_GALLERY_NAME_PARTS = new Set([
  'and',
  'the',
  'for',
  'with',
  'organic',
  'dried',
  'fruit',
  'fruits',
  'juice',
  'food',
  'beverages',
  'flavored',
  'paste',
  'water',
  'drink',
]);

function distinctiveGalleryNameTokens(name) {
  const slug = slugKeyProductName(name);
  if (!slug) return [];
  return slug.split('-').filter((t) => t.length > 2 && !GENERIC_GALLERY_NAME_PARTS.has(t));
}

/**
 * Yerel galeri dosya adları ürün adıyla uyumlu mu.
 * `null` = addan anlamlı parça çıkmadı (önceki distinct-only mantığına bırak).
 */
function galleryPathsLikelyMatchProduct(product, urls) {
  let tokens = [
    ...new Set([
      ...distinctiveGalleryNameTokens(product?.name || ''),
      ...distinctiveGalleryNameTokens(product?.name_tr || ''),
    ]),
  ];
  if (tokens.includes('incir')) tokens = [...new Set([...tokens, 'fig'])];
  if (!tokens.length) return null;
  const list = Array.isArray(urls) ? urls : [];
  if (!list.length) return false;
  const sample = list.slice(0, 24);
  let matched = 0;
  for (const u of sample) {
    const file = lastPathSegmentFromUrl(u);
    if (!file) continue;
    const stem = wpStripScaledSuffixes(file);
    if (tokens.some((t) => stem.includes(t))) matched++;
  }
  const need = Math.max(2, Math.ceil(sample.length * 0.34));
  return matched >= need;
}

/** Yerel `/uploads/...` girdileri Woo `Images` ile aynı dosya setini mi işaret ediyor (yol öneki bağımsız). */
function catalogUploadPathsAlignWithWooGallery(uploadPaths, wooUrls) {
  if (!Array.isArray(uploadPaths) || !uploadPaths.length) return false;
  if (!Array.isArray(wooUrls) || !wooUrls.length) return false;
  const keys = new Set();
  for (const u of wooUrls) {
    const k = galleryAlignmentKeyFromUrl(u);
    if (k) keys.add(k);
  }
  return uploadPaths.every((u) => {
    const k = galleryAlignmentKeyFromUrl(u);
    return Boolean(k && keys.has(k));
  });
}

/**
 * `/catalog-images/...` satırlarının çoğu Woo `Images` ile aynı varlıkları mı gösteriyor.
 * Tek bir yanlış klasör/extra dosya tüm `.every()` eşlemesini kırmaması için çoğunluk kullanılır.
 */
function catalogPathsMostlyAlignWithWooGallery(catalogPaths, wooUrls) {
  if (!Array.isArray(catalogPaths) || !catalogPaths.length) return false;
  if (!Array.isArray(wooUrls) || !wooUrls.length) return false;
  const keys = new Set();
  for (const u of wooUrls) {
    const k = galleryAlignmentKeyFromUrl(u);
    if (k) keys.add(k);
  }
  let ok = 0;
  for (const u of catalogPaths) {
    const k = galleryAlignmentKeyFromUrl(u);
    if (k && keys.has(k)) ok++;
  }
  const need = Math.max(1, Math.ceil(catalogPaths.length * 0.5));
  return ok >= need;
}

/** Woo + yerel birleşiminde aynı dosyanın hem `/uploads/` hem https kopyasını tek URL’de tutar. */
function dedupeUrlsByAssetKey(urls) {
  if (!Array.isArray(urls) || !urls.length) return [];
  const out = [];
  const seen = new Set();
  for (const u of urls) {
    const s = String(u || '').trim();
    if (!s) continue;
    const k = galleryAlignmentKeyFromUrl(s) || canonicalGalleryKeyFromUrl(s);
    if (!k) continue;
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(s);
  }
  return out;
}

/**
 * Piksel alanı: ölçek eki yoksa çok büyük (orijinal); varsa w*h — büyük olan tercih.
 * Aynı canonical anahtarda tek URL bırakır; sıra ilk geçiş sırasına göre.
 */
function variantAreaRank(url) {
  const file = lastPathSegmentFromUrl(url);
  if (!file) return -1;
  const m = file.match(/-(\d+)x(\d+)\.[^.]+$/i);
  if (!m) return 1e12;
  const w = Number(m[1]);
  const h = Number(m[2]);
  return Number.isFinite(w) && Number.isFinite(h) ? w * h : -1;
}

/** Varsayılan ~280×280; liste önizlemesinde daha küçük Woo varyantı seçilir (`REACT_APP_PRODUCT_GALLERY_MIN_PIXEL_AREA` ile geçersiz kılınır). */
const DEFAULT_PRODUCT_GALLERY_MIN_PIXEL_AREA = 280 * 280;

export function productGalleryMinPixelArea() {
  const n = Number(String(process.env.REACT_APP_PRODUCT_GALLERY_MIN_PIXEL_AREA || '').trim());
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_PRODUCT_GALLERY_MIN_PIXEL_AREA;
}

/**
 * Dosya adında Woo ölçeği (`-150x150.jpg`) varsa alan eşiğin altındaysa galeri/hero için kullanılmaz.
 * Ölçek eki yoksa tam görsel kabul edilir (URL’den çözünürlük okunamadığı için elenmez).
 */
export function isAcceptableProductGalleryImageUrl(url) {
  if (!url || !String(url).trim()) return false;
  const rank = variantAreaRank(url);
  if (rank === 1e12) return true;
  if (rank < 0) return true;
  return rank >= productGalleryMinPixelArea();
}

/**
 * Woo galeri / API tekrarları: aynı görselin farklı boyutlarını tek URL’de birleştirir.
 */
export function dedupeGalleryRealImages(urls) {
  if (!Array.isArray(urls) || !urls.length) return [];
  const byKey = new Map();
  for (let i = 0; i < urls.length; i++) {
    const u = urls[i];
    if (!u || !String(u).trim()) continue;
    const k = canonicalGalleryKeyFromUrl(u);
    if (!k) continue;
    const area = variantAreaRank(u);
    const prev = byKey.get(k);
    if (!prev || area > prev.area || (area === prev.area && i < prev.index)) {
      byKey.set(k, { url: u, area, index: i });
    }
  }
  return [...byKey.values()]
    .sort((a, b) => a.index - b.index)
    .map((x) => x.url)
    .filter(isAcceptableProductGalleryImageUrl);
}

/**
 * Kart ızgarası: aynı görsel için mümkün olan **en küçük** Woo `WxH` varyantını tercih eder (daha az veri).
 * Tam URL’de ölçek yoksa olduğu gibi kullanılır. Ürün detayı için `dedupeGalleryRealImages` büyük kalır.
 */
function pickPreviewVariantForCanonicalGroup(urls) {
  const list = (urls || []).map((u) => String(u || '').trim()).filter(Boolean);
  if (!list.length) return '';
  if (list.length === 1) return list[0];

  const MIN_A = productGalleryMinPixelArea();
  const items = list.map((u) => ({ u, area: variantAreaRank(u) }));
  const sized = items.filter((x) => x.area > 0 && x.area < 1e12);
  if (sized.length) {
    const bigEnough = sized.filter((x) => x.area >= MIN_A);
    if (bigEnough.length) {
      bigEnough.sort((a, b) => a.area - b.area);
      return bigEnough[0].u;
    }
    sized.sort((a, b) => b.area - a.area);
    return sized[0].u;
  }
  return list[0];
}

export function dedupeGalleryPreviewImages(urls) {
  if (!Array.isArray(urls) || !urls.length) return [];
  const byKey = new Map();
  const order = [];
  for (let i = 0; i < urls.length; i++) {
    const u = urls[i];
    if (!u || !String(u).trim()) continue;
    const k = canonicalGalleryKeyFromUrl(u);
    if (!k) continue;
    if (!byKey.has(k)) {
      byKey.set(k, []);
      order.push(k);
    }
    byKey.get(k).push(String(u).trim());
  }
  const out = [];
  for (const k of order) {
    const group = byKey.get(k);
    const picked = pickPreviewVariantForCanonicalGroup(group);
    if (picked) out.push(picked);
  }
  return out;
}

/** Woo export `wc_raw.Images` hücresinden ayrıştırılmış URL listesi (tek kaynak). */
function urlsFromWcRawImagesCell(product) {
  const wc = product?.wc_raw;
  if (!wc || typeof wc !== 'object') return [];
  const cell =
    wc.Images ||
    wc.images ||
    wc['Images'] ||
    wc['image urls'] ||
    wc['Image URLs'] ||
    '';
  if (typeof cell !== 'string' || !cell.trim()) return [];
  const parsed = cell
    .split(',')
    .map((x) => x.trim())
    .filter(
      (u) =>
        /^https?:\/\//i.test(u) ||
        u.startsWith('/uploads/') ||
        u.startsWith('/catalog-images/'),
    )
    .filter((u) => !isDiscardedExternalProductImage(u));
  return dedupeProductImageUrls(parsed);
}

/** Ham galeri URL listesinde aynı görselin (WxH / `-scaled` / tekrar satır) yalnızca biri kalır. */
function dedupeRawGalleryUrls(urls) {
  if (!Array.isArray(urls) || !urls.length) return [];
  const out = [];
  const seen = new Set();
  for (const u of urls) {
    if (!u || !String(u).trim()) continue;
    const k = canonicalGalleryKeyFromUrl(u);
    if (!k) continue;
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(String(u).trim());
  }
  return out;
}

/**
 * Kart + ürün detayı: `gallery` + Woo `wc_raw.Images` birlikte değerlendirilir.
 * - Yerel galeri dosya adları ürün adıyla uyuşmuyorsa (ör. incir ürününde hep `dried-apricot`) → Woo.
 * - Uyuşmaz ama `product.gallery` içindeki `/uploads/...` yolları Woo ile canonical hizalıysa → önce bu
 *   yollar (ör. Grape Juice: dosya adları sayısal; isim eşleşmesi zayıf kalır, yerel dosyalar doğrudur).
 * - Uyuşuyor ve tek görselin çok boyutuysa (aynı canonical) → Woo.
 * - Uyuşuyor ve birden fazla gerçek görsel varsa → yerel galeri (jam vb.; public/uploads eşleşmesi).
 */
export function collectProductGalleryRawUrls(product) {
  if (!product) return [];
  const fromWc = urlsFromWcRawImagesCell(product);
  const fromApi = Array.isArray(product.gallery)
    ? product.gallery.filter(Boolean).filter((u) => !isDiscardedExternalProductImage(u))
    : [];

  if (fromWc.length >= 2 && fromApi.length >= 2) {
    const likely = galleryPathsLikelyMatchProduct(product, fromApi);
    if (likely === false) {
      const uploadPathsFromGallery = fromApi.filter((u) =>
        String(u).trimStart().startsWith('/uploads/'),
      );
      const catalogPathsFromGallery = fromApi.filter((u) =>
        String(u).trimStart().startsWith('/catalog-images/'),
      );
      if (
        uploadPathsFromGallery.length >= 1 &&
        catalogUploadPathsAlignWithWooGallery(uploadPathsFromGallery, fromWc)
      ) {
        return dedupeRawGalleryUrls(
          dedupeUrlsByAssetKey(dedupeProductImageUrls([...uploadPathsFromGallery, ...fromWc])),
        );
      }
      if (
        catalogPathsFromGallery.length >= 1 &&
        catalogPathsMostlyAlignWithWooGallery(catalogPathsFromGallery, fromWc)
      ) {
        return dedupeRawGalleryUrls(dedupeProductImageUrls(fromApi));
      }
      return dedupeRawGalleryUrls(fromWc);
    }
    const distinctLocal = countDistinctCanonicalGallerySubjects(fromApi);
    if (likely === null) {
      if (distinctLocal <= 1) return dedupeRawGalleryUrls(fromWc);
      return dedupeRawGalleryUrls(dedupeProductImageUrls(fromApi));
    }
    if (distinctLocal <= 1) return dedupeRawGalleryUrls(fromWc);
    return dedupeRawGalleryUrls(dedupeProductImageUrls(fromApi));
  }
  if (fromWc.length >= 2) return dedupeRawGalleryUrls(fromWc);
  if (fromApi.length >= 2) return dedupeRawGalleryUrls(dedupeProductImageUrls(fromApi));
  if (fromWc.length === 1) return dedupeRawGalleryUrls(fromWc);
  if (fromApi.length >= 1) return dedupeRawGalleryUrls(dedupeProductImageUrls(fromApi));
  return dedupeRawGalleryUrls(
    product.image && !isDiscardedExternalProductImage(product.image) ? [product.image] : [],
  );
}

/** Ürün görseli + yerel placeholder ikisi de yüklenemezse: src kaldır, çerçeve rengi kalır (data: URL yok). */
function markProductImageMissing(el) {
  el.dataset.imgFallback = '1';
  el.removeAttribute('srcset');
  el.removeAttribute('data-img-src-chain');
  delete el.dataset.imgSrcChain;
  delete el.dataset.imgChainIdx;
  el.removeAttribute('src');
  el.alt = '';
  el.style.opacity = '0';
}

/**
 * Woo/WordPress çoğu yüklemede `-768x768.webp` gibi türetilmiş dosyalar üretir; CSV/API bazen yalnızca
 * orijinali verir — o zaman çok büyük bayt iner. Bu mod, standart WxH adlarını dener; 404 olursa
 * `applyProductImageFallback` sırayla orijinale düşer (`data-img-src-chain`).
 */
function wooDerivedImageChainEnabled() {
  const v = String(process.env.REACT_APP_WOO_DERIVED_IMAGE_CHAIN ?? 'true').trim().toLowerCase();
  if (v === 'false' || v === '0' || v === 'no') return false;
  return true;
}

function isLikelyWooUploadMediaUrl(url) {
  try {
    const u = new URL(String(url || '').trim().split('#')[0]);
    const p = u.pathname.toLowerCase();
    return (
      p.includes('/wp-content/uploads/') || p.includes('/uploads/') || p.includes('/catalog-images/')
    );
  } catch {
    return false;
  }
}

/** Dosya adından kök + uzantı; `-1200x800` ve `-scaled` eklerini sökerek “asıl” isim. */
function wpImageStemBaseAndExt(filename) {
  const file = String(filename || '').trim();
  const m = file.match(/^(.+?)(\.(jpe?g|png|webp|gif))$/i);
  if (!m) return null;
  let base = m[1];
  const ext = m[2].toLowerCase();
  for (let g = 0; g < 16; g++) {
    const next = base.replace(/-\d+x\d+$/i, '');
    if (next === base) break;
    base = next;
  }
  base = base.replace(/-scaled$/i, '');
  if (!base) return null;
  return { base, ext };
}

/**
 * Aynı klasörde `stem-WxH.ext` URL’si üretir (WordPress orta/büyük ölçek adlandırması).
 * Dosya yoksa 404 — `buildImageFallbackChain` + onError ile orijinale geçilir.
 */
function parseProductMediaUrl(rawInput) {
  const raw = String(rawInput || '').trim().split('#')[0];
  if (!raw) return null;
  if (raw.startsWith('/') && !raw.startsWith('//')) {
    const q = raw.indexOf('?');
    const pathname = q >= 0 ? raw.slice(0, q) : raw;
    const search = q >= 0 ? raw.slice(q) : '';
    return { origin: '', pathname, search, relative: true };
  }
  const u = new URL(raw.startsWith('//') ? `https:${raw}` : raw);
  return { origin: u.origin, pathname: u.pathname, search: u.search || '', relative: false };
}

function joinMediaPath(origin, pathname, search, relative) {
  const joined = `${origin}${pathname}${search || ''}`.replace(/([^:]\/)\/+/g, '$1');
  return relative ? `${pathname}${search || ''}`.replace(/\/\/+/g, '/') : joined;
}

/** Woo `stem-WxH.ext` — optimizeCatalogImages.js ile üretilen webp türevleri dahil. */
export function wooGuessedResizeUrl(absoluteUrl, w, h, extOverride) {
  const wInt = Math.max(1, Math.min(4096, Math.round(Number(w))));
  const hInt = Math.max(1, Math.min(4096, Math.round(Number(h))));
  try {
    const parsed = parseProductMediaUrl(absoluteUrl);
    if (!parsed) return '';
    const file = parsed.pathname.split('/').pop() || '';
    const pair = wpImageStemBaseAndExt(file);
    if (!pair) return '';
    const ext = extOverride || pair.ext;
    const dir = parsed.pathname.slice(0, Math.max(0, parsed.pathname.lastIndexOf('/')));
    const newPath = `${dir}/${pair.base}-${wInt}x${hInt}${ext}`;
    return joinMediaPath(parsed.origin, newPath, parsed.search, parsed.relative);
  } catch {
    return '';
  }
}

function wooGuessedResizeWebpUrl(url, w, h) {
  return wooGuessedResizeUrl(url, w, h, '.webp');
}

/** Zaten küçük `-WxH-` dosyası varsa türetme zincirine gerek yok; isimsiz orijinallerde dene. */
function shouldUseDerivedImageFallbackChain(resolvedUrl, profile = 'card') {
  const u = String(resolvedUrl || '').trim();
  if (!u || isPlaceholderImageSrc(u)) return false;
  if (!wooDerivedImageChainEnabled()) return false;
  if (!isLikelyWooUploadMediaUrl(u)) return false;
  const rank = variantAreaRank(u);
  if (rank < 0) return false;
  if (rank > 0 && rank < 1e12) {
    // Kart/thumb: dosya adında zaten `-1200x800` gibi ölçü var — stem'den yeni boyut türetmek çoğu zaman 404.
    if (profile === 'card' || profile === 'thumb') return false;
    const maxPx = 650;
    return rank > maxPx * maxPx;
  }
  return true;
}

/**
 * @param {string} resolvedUrl — `resolveProductImageUrl` çıktısı
 * @param {'card' | 'hero' | 'thumb'} profile
 * @returns {string[]}
 */
export function buildImageFallbackChain(resolvedUrl, profile = 'card') {
  const u = String(resolvedUrl || '').trim();
  if (!u) return [''];
  const rank = variantAreaRank(u);
  /** Zaten yüksek çözünürlüklü türev — tekrar türetme (yanlış URL / kırık img). */
  if (profile === 'hero' && rank >= 1600 * 1600 && rank < 1e12) {
    return [u];
  }
  if (!shouldUseDerivedImageFallbackChain(u, profile)) return [u];

  /**
   * Kart: optimizeCatalogImages.js ile üretilen webp boyutları (400/800/1600).
   * Hero: detay/LCP için orta-yüksek çözünürlük önce.
   */
  const dims =
    profile === 'hero'
      ? [
          [3840, 3840],
          [2048, 2048],
          [1600, 1600],
          [1200, 1200],
          [1024, 1024],
          [800, 800],
        ]
      : profile === 'thumb'
        ? [
            [400, 400],
            [800, 800],
          ]
        : [
            [400, 400],
            [800, 800],
            [1600, 1600],
          ];

  const out = [];
  const seen = new Set();
  const push = (cand) => {
    if (cand && !seen.has(cand)) {
      seen.add(cand);
      out.push(cand);
    }
  };
  /** Dosya adında `-WxH-` yoksa türetilmiş URL’ler çoğu zaman 404 — önce orijinali dene. */
  const unsizedOriginal = rank >= 1e12;
  const originalFirst = unsizedOriginal || profile === 'card' || profile === 'thumb';
  if (originalFirst) push(u);
  for (const [w, h] of dims) {
    if (profile === 'card' || profile === 'thumb') {
      push(wooGuessedResizeWebpUrl(u, w, h));
    }
    if (profile === 'hero') {
      push(wooGuessedResizeWebpUrl(u, w, h));
    }
    push(wooGuessedResizeUrl(u, w, h));
  }
  if (!originalFirst && !seen.has(u)) push(u);
  return out.length ? out : [u];
}

/**
 * Ürün kartı ile aynı mantıkta görsel URL zinciri (liste ön yükleme / önbellek ile uyumlu).
 * @param {object|null|undefined} product
 * @returns {string[]}
 */
export function buildProductCardImageChain(product) {
  if (!product) return [PRODUCT_PLACEHOLDER_SRC];
  const galleryRaw = collectProductGalleryRawUrls(product);
  const gallery = dedupeGalleryPreviewImages(
    galleryRaw.map((u) => resolveProductImageUrl(u)).filter(Boolean),
  );
  const imageFirst =
    gallery[0] ||
    resolveProductImageUrl(pickCatalogHeroSrc(product, galleryRaw)) ||
    PRODUCT_PLACEHOLDER_SRC;
  return buildImageFallbackChain(imageFirst, 'card');
}

/** Kart grid için srcSet (küçük türevler önce). */
export function buildCardImageSrcSet(chain) {
  if (!Array.isArray(chain) || chain.length <= 1) return undefined;
  const widths = [400, 800, 1200];
  const parts = [];
  for (let i = 0; i < chain.length && i < widths.length; i++) {
    const url = String(chain[i] || '').trim();
    if (!url || isPlaceholderImageSrc(url)) continue;
    parts.push(`${url} ${widths[i]}w`);
  }
  return parts.length > 1 ? parts.join(', ') : undefined;
}

/** Ürün detay hero için srcSet (yüksek çözünürlük). */
export function buildHeroImageSrcSet(chain) {
  if (!Array.isArray(chain) || chain.length <= 1) return undefined;
  const widths = [3840, 2048, 1600, 1200, 1024, 800];
  const parts = [];
  for (let i = 0; i < chain.length && i < widths.length; i++) {
    const url = String(chain[i] || '').trim();
    if (!url || isPlaceholderImageSrc(url)) continue;
    parts.push(`${url} ${widths[i]}w`);
  }
  return parts.length > 1 ? parts.join(', ') : undefined;
}

/** `<img {...productImageChainDataAttrs(chain)} src={chain[0]} />` — 404’da zincirle sıradaki URL. */
export function productImageChainDataAttrs(chain) {
  if (!Array.isArray(chain) || chain.length <= 1) return {};
  return { 'data-img-src-chain': JSON.stringify(chain) };
}

/** After img onerror: bir kez /product-placeholder.png dene; o da olmazsa src’yi temizle (krem arka plan). */
export function applyProductImageFallback(event) {
  const el = event?.currentTarget;
  if (!el || el.dataset.imgFallback === '1') return;

  const chainRaw = el.getAttribute('data-img-src-chain') || el.dataset.imgSrcChain;
  if (chainRaw) {
    try {
      const chain = JSON.parse(chainRaw);
      if (Array.isArray(chain) && chain.length > 1) {
        let idx = Number(el.dataset.imgChainIdx || '0');
        idx += 1;
        if (idx < chain.length) {
          el.dataset.imgChainIdx = String(idx);
          el.removeAttribute('srcset');
          el.src = chain[idx];
          return;
        }
        const origin = String(chain[0] || '').trim();
        const cur = el.currentSrc || el.getAttribute('src') || '';
        if (origin && !el.dataset.imgChainOriginTried && cur !== origin) {
          el.dataset.imgChainOriginTried = '1';
          el.removeAttribute('srcset');
          el.src = origin;
          return;
        }
      }
    } catch {
      /* fall through */
    }
  }

  el.removeAttribute('srcset');
  const placeholder = PRODUCT_PLACEHOLDER_SRC;

  if (el.dataset.imgFbStep === '1') {
    markProductImageMissing(el);
    return;
  }
  const cur = el.currentSrc || el.getAttribute('src') || '';
  if (isPlaceholderImageSrc(cur)) {
    markProductImageMissing(el);
    return;
  }
  el.dataset.imgFbStep = '1';
  el.src = placeholder;
}

/** First hero src: yeterli çözünürlükte galeri, yoksa ana görsel, yoksa placeholder. */
export function pickCatalogHeroSrc(product, galleryUrls) {
  const list = Array.isArray(galleryUrls) ? galleryUrls : [];
  const g0 = list.map((u) => String(u || '').trim()).find((u) => u && isAcceptableProductGalleryImageUrl(u));
  if (g0) return g0;
  const img = product?.image;
  const imgStr = img && String(img).trim();
  if (imgStr && !isDiscardedExternalProductImage(imgStr) && isAcceptableProductGalleryImageUrl(imgStr)) {
    return imgStr;
  }
  return PRODUCT_PLACEHOLDER_SRC;
}

/**
 * Ürün detayı galerisi: en yüksek kabul edilebilir Woo varyantı (kart önizlemesinden daha büyük).
 */
export function pickProductDetailGalleryUrls(product) {
  if (!product) return [];
  const raw = collectProductGalleryRawUrls(product);
  const resolved = raw.map((u) => resolveProductImageUrl(u)).filter(Boolean);
  const real = dedupeGalleryRealImages(resolved);
  if (real.length) return real.slice(0, 12);
  return resolved.length ? dedupeProductImageUrls(resolved).slice(0, 12) : [];
}

/**
 * Ürün detayı / LCP: Woo `-WxH-` galeri varyantlarından **kart ile aynı** küçük-yeterli seçim
 * (`dedupeGalleryPreviewImages`). Tam boy görsel yerine çok daha az bayt — yükleme süresini kısaltır.
 */
export function pickProductDisplayGalleryUrls(product) {
  if (!product) return [];
  const raw = collectProductGalleryRawUrls(product);
  const resolved = raw.map((u) => resolveProductImageUrl(u)).filter(Boolean);
  const preview = dedupeGalleryPreviewImages(resolved);
  if (preview.length) return preview;
  return resolved.length ? dedupeProductImageUrls(resolved).slice(0, 8) : [];
}

/** Liste, ilişkili ürün spotu: tek kahraman URL (önizleme boyutu). */
export function pickProductHeroPreviewUrl(product) {
  if (!product) return resolveProductImageUrl(PRODUCT_PLACEHOLDER_SRC);
  const urls = pickProductDisplayGalleryUrls(product);
  if (urls.length) return urls[0];
  const raw = collectProductGalleryRawUrls(product);
  return (
    resolveProductImageUrl(pickCatalogHeroSrc(product, raw)) ||
    resolveProductImageUrl(PRODUCT_PLACEHOLDER_SRC)
  );
}
